var _ = require('underscore'),
	Raphael = require('raphael'),
	ShapeUtils = require('../shapeUtils'),
	CoordinateShape = require('./coordinate');

// Kind of a hybrid 'coordinate' shape: doesn't have 'coordinates' but when read in,
// converts x, y, width and height values to coordinates to share functions when rendering from model.
module.exports = CoordinateShape.extend({

	glowColor: '#f89406', // defined b/c the image will have no fill or stroke ( not inherited from the shape ) -- orange; same as that used for the stamp note color
	hoverOpacity: 0.5,
	placedOpacity: 0.8, // use this so can see underneath the image -- a 'compromise'
	// all of these can be gotten from the parent note model ... passing in for more clarity ( i guess i used to be much more into brevity )
	defaults: function() {
		return _.extend( {}, CoordinateShape.prototype.defaults.apply(this, arguments) , {
			x: 0,
			y: 0,
			width: 0,
			height: 0,
			graphicStampHeader: null
		});
	},

	// Note for new unsaved stamps, parse is called but is really N/A --
	// Page Note Width/Height not yet set, eg.
	parse: function(attrs) {
		attrs = CoordinateShape.prototype.parse.apply(this, arguments);
		attrs.points = this._generatePtsArray(attrs);
        return attrs;

    },
	// request with the rotation of the page b/c
	// stamps are stored rotated at the 'inverse' rotation of the page in which they were created
	getImgUrl: function() {
		return this.parentNote.getImgSource( this.pageModel.get('rotation') );
	},
    // Create an array of coordinate pts from the dimensions of the image.
	// This is used to facilitate rendering from the model with the necessary conversion adjustments like Coordinate Shapes
    _generatePtsArray: function(attrs) {
		var attrs = attrs || this.attributes,
			x = attrs.x,
			x2 = x + attrs.width,
			y = attrs.y,
			y2 = y + attrs.height;
		return [
			{ x: x,  y: y  },
			{ x: x2, y: y  },
			{ x: x2, y: y2 },
			{ x: x,  y: y2 }
		];
    },
	getAttrsToPersist: function(scale) {

		var el = this.uiModel.get('raphaelEl'),
			pg = this.pageModel,
			cc = ShapeUtils.INCHES_TENTHS_MM_TRANS,
			box;

		if ( !pg.isCold() ) {

			var conv = cc * pg.getDPI();

			// get the bbox of the unadjusted path utilizing fn taken from graphic svg shapes
			// especially convenient for get the x, y values if rotation is involved
			box = Raphael.pathBBox( Raphael.fn.viewerUnadjustedPath(
				el.getPathOfBBox(),
				scale,
				pg.get('rotation') % 360,
				pg.originalDimensions(scale),
				pg.getOriginalCenterPtRotated(scale)
			));

			// Round to nearest integer -- in the Java code the placement attributes are integers
			// (though that could be a bug; they are type 'number' in Oracle)
			return {
				x: Math.round(box.x / conv),
				y: Math.round(box.y / conv),
				width: Math.round(box.width / conv),
				height: Math.round(box.height / conv),
				src: el.attr('src') //note: this isn't the entire src obj -- never sending that to Java Server so will be removed anyway
			};

		} else {

			var o = this.pageModel.get('overlay');

			//use for convenience (not necessary, especially b/c these pages can't be rotated)
			box = Raphael.pathBBox( el.getPathOfBBox() );

			return {
				x: Math.round( ( box.x / cc / scale / 96 ) + ( o.xTextOffset * 254 ) ), // 254 is inches to 1/10 of mm
				y: Math.round( ( box.y / cc / scale / 96 ) + ( o.yTextOffset * 254 ) ),
				width: Math.round( box.width / cc / scale / 96 ) ,
				height: Math.round( box.height / cc / scale / 96 ) ,
				src: el.attr('src') //note: this isn't the entire src obj -- never sending that to Java Server so will be removed anyway
			};
		}

	},
	/**
	 * for this shape we don't take cpi/lpi into account
	 * need to account for the overlay offset here
	 * appears could be off here for rounding (like other shapes)
	 * depending on overlay offsets margins, some of the stamp may be cut off or not shown -- DVBC-1391
	**/
	_getColdPageAdjustedPointsArray: function(scale) {

		var cc = ShapeUtils.INCHES_TENTHS_MM_TRANS,
			pts = this.get('points'),
			o = this.pageModel.get('overlay');

		return _.map(pts, function(p) {
			// ( 96 pixels/inch is sorta like the DPI part of the calculation for image pages )
			return  {
				x: (p.x * scale * cc * 96) - (o.xTextOffset * 96 * scale),
				y: (p.y * scale * cc * 96) - (o.yTextOffset * 96 * scale)
			};
		});
	},
	getOriginalImgAspectRatio: function(pgRotation) {

		var ow = this.get('graphicStampHeader').width,
			oh = this.get('graphicStampHeader').length;

		if (pgRotation === 90 || pgRotation === 270) {
			ow = this.get('graphicStampHeader').length;
			oh = this.get('graphicStampHeader').width;
		}

		return ow / oh;
	}
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/coordinate/graphicStamp.js
 ** module id = 301
 ** module chunks = 0
 **/